import { render } from "./StaffBulkUpload.vue?vue&type=template&id=4620c42e&scoped=true"
import script from "./StaffBulkUpload.vue?vue&type=script&lang=js"
export * from "./StaffBulkUpload.vue?vue&type=script&lang=js"

import "./StaffBulkUpload.vue?vue&type=style&index=0&id=4620c42e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4620c42e"]])

export default __exports__